import React from 'react';
import {
    useMediaQuery
} from 'react-responsive';
import styled from 'styled-components';

import {
    formatCurrency
} from '../../../utils'
import { LIGHT_PINK_ORANGE, PALE, SOFT_TOMATO } from '../../colors';
import { ProductName, ProductUnitAmount, ProductUnitType } from '../../typography';
import { ReactComponent as IconPlus } from '../../../assets/plus.svg';

interface ProductCardProps{
    name: String;
    units: Array <{
        type: string,
        price: string
    }>;
    thumbnail: string;
    description: string;
    onPress: () => void;
    onAdd: (unitType: string) => void;
}

const ProductCard = (props: ProductCardProps) => {
    return (
        <Container>
            <Content>
                <Thumbnail
                     onClick={() => props.onPress()}
                >
                    <img
                        src={props.thumbnail} 
                    />
                </Thumbnail>
                <ProductName>{props.name.toUpperCase()}</ProductName>
                {props.units.map((unit) => (
                    <Units>
                        <ProductUnitType>{unit.type}</ProductUnitType>
                        
                        <ProductUnitAmount >
                            {formatCurrency(unit.price)}
                        </ProductUnitAmount>
                        <div
                            style={{
                                display: 'flex',
                            }}
                        >
                            <ButtonAdd
                                onClick={() => props.onAdd(unit.type)}
                            >
                                <ButtonIcon />
                            </ButtonAdd>
                        </div>
                    </Units>
                ))}
            </Content>
        </Container>
    )
}

export default ProductCard;

const Container = styled.div`

`;

const Content = styled.div`
    background-color: ${PALE};
    border-radius: 8px;
    padding: 1rem;
`;


const Thumbnail = styled.div`
    img {
        width: 100%;
        object-fit: cover;
    }
`;

const Units = styled.div`
    display: flex;
    padding: 0.3rem 0rem;
    align-items: center;

    > :nth-child(2) {
        // border: 1px solid red;
        flex: 1;
    }
`;

const ButtonAdd = styled.button`
    height: 20px;
    background-color: ${SOFT_TOMATO};
    color: white;
    border: none;
    border-radius: 10px;
    cursor: pointer;
`;

const ButtonIcon = styled(IconPlus)`
    height: 10px;
    width: 10px;
    fill: white;
    tint: white;
`;